<div class="book-card-component">
    <div *ngIf="!isLoading" class="card book-card" (click)="onCardClick($event, book)" (mouseover)="isHovered = true"
        (mouseleave)="isHovered = false">
        <div *ngIf="showEnabled" class="status-icon" [ngClass]="{ 'enabled': book.enabled, 'disabled': !book.enabled }">
        </div>
        <div class="card-body" [ngClass]="{ 'disabled-card': showEnabled && !book.enabled }">
            <div class="info-container">
                <mat-chip title="Book Status: Draft" class="draft-status"
                    *ngIf="showBookStatusIcon(UserBookStatusEnum.Draft)">D</mat-chip>
                <mat-chip title="Book Status: Waiting For Verification" class="waiting-for-verification-status"
                    *ngIf="showBookStatusIcon(UserBookStatusEnum.WaitingForVerification)">W</mat-chip>
                <mat-chip title="Book Status: Verified" class="verified-status"
                    *ngIf="showBookStatusIcon(UserBookStatusEnum.Verified)">V</mat-chip>
                <mat-chip title="Book Status: Published" class="published-status"
                    *ngIf="showBookStatusIcon(UserBookStatusEnum.Published)">P</mat-chip>
                <mat-chip title="Book Status: Retired" class="retired-status"
                    *ngIf="showBookStatusIcon(UserBookStatusEnum.Retired)">R</mat-chip>
            </div>
            <div class="image-container">
                <img [src]="book.ThumbnailUrl | transformUrl"
                    [ngClass]="{'default-thumbnail-class': !book.ThumbnailUrl}" alt="Book">
                <!-- White overlay on hover -->
                <div class="hover-overlay" *ngIf="isHovered"></div>
                <!-- Edit button appears only if canEdit is true AND isHovered -->
                <button *ngIf="canEdit && isHovered" class="edit-button" (click)="onEdit($event, book)" title="Edit">
                    Edit
                </button>
            </div>
        </div>

        <div class="card-footer" [ngClass]="{ 'disabled-card': showEnabled && !book.enabled }">
            <div class="footer-row">
                <span class="book-card-title" [title]="book.Title">{{book.Title}}</span>
                <div class="actions-group">
                    <!-- Manage Spellings -->
                    <button *ngIf="canManageSpellings" class="action-btn manage-spellings"
                        (click)="onManageSpellings($event, book)" title="Manage Spellings" type="button">
                        <mat-icon class="book-icon">menu_book</mat-icon>
                    </button>
                    <!-- Delete -->
                    <button *ngIf="canDelete" class="action-btn delete" (click)="onDelete($event, book)" title="Delete"
                        type="button">
                        <i class="bi bi-trash fs-6"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isLoading" class="card book-card loader">
        <div class="card-body">
            <div class="image-container">
                <!-- <img title="Thumbnail"  src="#"> -->
            </div>
        </div>

        <div class="card-footer">
            <div class="row">
                <div class="col-sm-10">
                </div>
                <div class="col-sm-2 delete-icon text-center">
                </div>
            </div>
        </div>
    </div>
</div>